import Vue from 'vue';

let EventBus = new Vue();

const old_on = EventBus.$on;
EventBus.$on = (...args) => {
    let result = old_on.apply(EventBus, args);
    Promise.resolve().then(_ => {
        if (typeof angular == 'undefined') return;
        var $body = angular.element(document.body);
        var $rootScope = $body.scope()?.$root?.$evalAsync();
    });
    return result;
}

export default EventBus;